import { createCreateActionType } from "@multiweb/reactUtils";

/**
 * Jméno modulu pro práci s oprávněními komponent. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "rights";

/**
 * Pomocná funkce pro vytvoření typu akce
 * @param actionType Typ akce
 */
const createActionType = createCreateActionType(NAME);

/**
 * Typ akce pro hromadné nastavení práv komponentám.
 */
export const SET_RIGHTS_FOR_COMPONENTS = createActionType("SET_RIGHTS_FOR_COMPONENTS");
/**
 * Typ interní akce pro nastavení práv jedné komponentě.
 */
export const SET_RIGHTS_INTERNAL = createActionType("SET_RIGHTS_INTERNAL");
/**
 * Typ akce pro hromadné odstranění práv komponent.
 */
export const REMOVE_RIGHTS_FOR_COMPONENTS = createActionType("REMOVE_RIGHTS_FOR_COMPONENTS");
